import {Injectable, Injector} from '@angular/core';
import {ApiResponse, BaseApiService} from '../../base-api.service';
import {RevisionsModelService} from '../../../Models/Warehouse/Revisions/revisions-model.service';

@Injectable({
  providedIn: 'root'
})
export class RevisionsApiService extends BaseApiService {

  constructor(
    protected override injector: Injector,
    public model: RevisionsModelService,
  ) {
    super(injector);
  }


  /**
   * Obtener revisiones
   *
   */
  getRevisions(save: boolean = true): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('getRevisiones', {}).subscribe({
        next: (response) => {
          if (save) {
            this.model.save(response.data);
          }

          resolve(response);
        },
        error: (err) => {
          reject(err)
        }
      });

    });

  }

}
